import { useNavigate } from 'react-router-dom';
import { GetCampaignParams } from '@features/campaigns';
import { stringify } from 'qs';
import { useCurrentUser } from '@features/users';
import { presentationToFile } from '@features/powerpoint';
import { GetLci3ReportParams } from '@components/Dashboard/dashboardSlice/campaignsApi';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import {
  buildPresentation,
  useExecutiveReportFields,
} from '@features/executive-report/subdomains/visitation';
import { clientDefaultValues } from '@features/executive-report/subdomains/visitation';
import { buildClientDefaultValuesV2 } from '@features/executive-report/subdomains/visitation/components/domain/client-default-values-v2';
import { BuildReportOptions } from '@features/executive-report/subdomains/visitation/utils/build-presentation';
import { useFeatures } from '@utils/hooks';

type VisitationExecutiveReportDownloadProps = {
  campaignId: number;
  campaignParams: Omit<GetCampaignParams, 'id'>;
  reportParams: Omit<GetLci3ReportParams, 'id'>;
};

export const VisitationExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: VisitationExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });
  const { pptRedesign } = useFeatures();

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const options: BuildReportOptions = pptRedesign
        ? {
            ...data,
            designVersion: 'v2',
            brandLogo: null,
            customFields: buildClientDefaultValuesV2(data.campaign.name),
          }
        : {
            ...data,
            designVersion: 'v1',
            brandLogo: null,
            customFields: clientDefaultValues(data.campaign.name),
          };

      const presentation = buildPresentation(options);

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
